import { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { config } from '../../Constants';
import { PageSpinner } from '../../components/spinner/Spinner';
import { InvestmentsTable } from '../../components/tables/Tables';

const Investments = () => {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = JSON.parse(secureLocalStorage.getItem('user-info'));
  const baseURL = config.baseURL;

  useEffect(() => {
    const fetchInvestments = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/investments/admin`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInvestments(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchInvestments();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return (
      <main className='content investments-page'>
        <div className='title'>
          <h1 className='title'>Investments</h1>
        </div>
        <PageSpinner />
      </main>
    );
  }

  return (
    <main className='content investments-page'>
      <div className='title'>
        <h1 className='title'>Investments</h1>
      </div>

      <div className='stats-row'>
        <div className='stat-card'>
          <span>Total Investments</span>
          <strong>{investments.length}</strong>
        </div>
        <div className='stat-card'>
          <span>Active</span>
          <strong>{investments.filter((i) => i.status === 'active').length}</strong>
        </div>
        <div className='stat-card'>
          <span>Completed</span>
          <strong>{investments.filter((i) => i.status === 'completed').length}</strong>
        </div>
        <div className='stat-card'>
          <span>Total Value</span>
          <strong>
            ${investments.reduce((sum, i) => sum + i.amount, 0).toLocaleString()}
          </strong>
        </div>
      </div>

      {investments.length > 0 ? (
        <InvestmentsTable data={investments} />
      ) : (
        <div className='no-data'>
          <p>No investments yet</p>
        </div>
      )}
    </main>
  );
};

export default Investments;
